import React, { useCallback, useMemo } from 'react';
import { reFormatPhone } from 'grilnica-share';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'grilnica-reactstrap';
var A11yFromHelperModalContent = function (_a) {
    var error = _a.error, closeModal = _a.closeModal;
    var renderTextList = useCallback(function (object) {
        var _a, _b;
        var textList = [];
        if (Array.isArray(object.text)) {
            for (var i = 0; i < ((_a = object.text) === null || _a === void 0 ? void 0 : _a.length); i++) {
                var classNameTextResult = object.marginBottomText && i !== ((_b = object.text) === null || _b === void 0 ? void 0 : _b.length) - 1
                    ? object.marginBottomText
                    : 'mb-0';
                textList.push(React.createElement("p", { key: 'textItem' + i, className: classNameTextResult }, object.text[i]));
            }
        }
        else {
            if (object.actionType === 'call') {
                textList.push(React.createElement("a", { key: 'textItem', href: 'tel:' + reFormatPhone(object.action), className: 'mb-0' }, object.text));
            }
            else {
                textList.push(React.createElement("p", { key: 'textItem', className: 'mb-0' }, object.text));
            }
        }
        return textList;
    }, []);
    var renderModalBodyList = useCallback(function (a11yErrorBody) {
        var bodyBlockItem = [];
        for (var _i = 0, a11yErrorBody_1 = a11yErrorBody; _i < a11yErrorBody_1.length; _i++) {
            var object = a11yErrorBody_1[_i];
            var renderText = renderTextList(object);
            var classNameBodyResult = (object.color ? object.color : 'text-gray-900') +
                ' ' +
                (object.weight ? object.weight : '') +
                ' ' +
                (object.marginBottom ? object.marginBottom : 'mb-x3');
            bodyBlockItem.push(React.createElement("div", { key: 'bodyItem' + object.sorting, className: classNameBodyResult }, renderText));
        }
        return bodyBlockItem;
    }, [renderTextList]);
    var renderModalContent = useCallback(function (a11yErrorBody) {
        var bodyBlock = null;
        if ((a11yErrorBody === null || a11yErrorBody === void 0 ? void 0 : a11yErrorBody.length) > 0) {
            a11yErrorBody.sort(function (a, b) {
                if (a.sorting < b.sorting) {
                    return -1;
                }
                if (a.sorting > b.sorting) {
                    return 1;
                }
                return 0;
            });
            var bodyBlockItem = renderModalBodyList(a11yErrorBody);
            if (bodyBlockItem.length > 0) {
                bodyBlock = React.createElement(React.Fragment, null, bodyBlockItem);
            }
        }
        return bodyBlock;
    }, [renderModalBodyList]);
    var renderContent = useMemo(function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(ModalHeader, { isModalAdmin: true }, (error === null || error === void 0 ? void 0 : error.header) ? (React.createElement("p", { className: 'text-head-e-modal mb-0' }, error === null || error === void 0 ? void 0 : error.header.text)) : (React.createElement("p", { className: 'text-head-e-modal mb-0' }, "\u041E\u0448\u0438\u0431\u043A\u0430"))),
            React.createElement(ModalBody, { isModalAdmin: true, className: 'sec-subtitle1' }, renderModalContent(error.body)),
            React.createElement(ModalFooter, { isModalAdmin: true },
                React.createElement(Button, { type: 'button', color: 'primary', size: 'sm', onClick: closeModal }, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"))));
    }, [error, closeModal, renderModalContent]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { A11yFromHelperModalContent };
//# sourceMappingURL=A11yFromHelperModalContent.js.map